module.exports = __webpack_public_path__ + "img/2x.745be29.jpg";